import {
	createContext,
	useContext,
	useState,
	useCallback,
	useEffect,
} from "react";
import Groq from "groq-sdk";
import { GoogleGenAI } from "@google/genai";
import axios from "axios";
import { allFilterText, baseUrl } from "../utils/OtherUtils";
import { useParams, useNavigate } from "react-router-dom";
//import { useAuthContext } from "./AuthContext";

const TestContext = createContext();

const TestProvider = ({ children }) => {
	//const { handleNotification } = useAuthContext();
	const navigate = useNavigate();
	const [selectedProductType, setSelectedProductType] = useState("Home");
	const [allProducts, setAllProducts] = useState([]);
	const [paginationInfo, setPaginationInfo] = useState({
		currentPage: 0,
		totalPages: null,
		totalProducts: null,
	});
	const { id } = useParams();
	const [product, setProduct] = useState(null);
	const [filteredProducts, setFilteredProducts] = useState([]);
	const [filterPaginationInfo, setFilterPaginationInfo] = useState({
		currentPage: 1,
		totalPages: 0,
		totalProducts: 0,
	});
	const [brandProducts, setBrandProducts] = useState([]);
	const [brandPaginationInfo, setBrandPaginationInfo] = useState({
		currentPage: 1,
		totalPages: 0,
		totalProducts: 0,
	});
	const [searchQuery, setSearchQuery] = useState("");
	const [globalSearchData, setGlobalSearchData] = useState([]);
	const [globalSearchPagination, setGlobalSearchPagination] = useState({
		currentPage: 1,
		totalPages: 0,
		totalProducts: 0,
	});
	const [productTypeData, setProductTypeData] = useState([]);
	const [productTypePagination, setProductTypePagination] = useState({
		currentPage: 1,
		totalPages: 0,
		totalProducts: 0,
	});
	const [categoryProducts, setCategoryProducts] = useState([]);
	const [categoryProductsPagination, setCategoryProductsPagination] = useState({
		currentPage: 1,
		totalPages: 0,
		totalProducts: 0,
	});
	const [radiologyProducts, setRadiologyProducts] = useState([]);
	const [radiologyProductsPagination, setRadiologyProductsPagination] =
		useState({
			currentPage: 1,
			totalPages: 0,
			totalProducts: 0,
		});
	const [productsByBrandAndType, setProductsByBrandAndType] = useState([]);
	const [productsByBrandAndQuery, setProductsByBrandAndQuery] = useState([]);

	const [globalSearchQuery, setGlobalSearchQuery] = useState("");
	const [navbarSearchQuery, setNavbarSearchQuery] = useState("");
	const [productsByBrandAndTypeAndQuery, setProductsByBrandAndTypeAndQuery] =
		useState([]);
	const [productsBySearchQuery, setProductsBySearchQuery] = useState([]);
	const [productsBySearchQueryPagination, setProductsBySearchQueryPagination] =
		useState({
			currentPage: 1,
			totalPages: 0,
			totalProducts: 0,
		});
	const [productsToBeSearched, setProductsToBeSearched] = useState([]);
	const [allProductsSearched, setAllProductsSearched] = useState([]);
	const [
		productsByBrandAndTypeAndQueryPagination,
		setProductsByBrandAndTypeAndQueryPagination,
	] = useState({
		currentPage: 1,
		totalPages: 0,
		totalProducts: 0,
	});

	const [popularProducts, setPopularProducts] = useState([]);
	const [searchedProducts, setSearchedProducts] = useState([]);

	const [selectedSearchData, setSelectedSearchData] = useState({});
	const [productTitleList, setProductTitleList] = useState([]);
	const [filters, setFilters] = useState({
		productCategory: "r1",
		productType: "pathology",
	});

	const [isDebounceDropdown, setIsDebounceDropdown] = useState(false);
	const [fromProductFilter, setFromProductFilter] = useState({
		status: false,
		text: "",
	});

	const handleGlobalSearchChange = (e) => {
		setSearchQuery(e.target.value);
	};

	// Fetch all products with pagination
	const fetchProducts = useCallback(async (page = 1) => {
		const url = `${baseUrl}/api/products/allproducts?page=${page}`;
		// console.log("product", url);

		try {
			const response = await axios.get(url);

			if (response?.data?.success) {
				setAllProducts((prevProducts) => [
					...prevProducts,
					...(response?.data?.data?.products || []),
				]);
				setProductTitleList((prevProductTitles) => [
					...prevProductTitles,
					...response?.data?.data?.products.map(
						(product) => product.productTitle
					),
				]);
				setPaginationInfo({
					currentPage: response?.data?.data?.pagination?.currentPage,
					totalPages: response?.data?.data?.pagination?.totalPages,
					totalProducts: response?.data?.data?.pagination?.totalProducts,
				});
			}
		} catch (error) {
			console.log("Error occurred:", error);
		}
	}, []);

	// Fetch product by ID
	const fetchProductById = useCallback(async () => {
		const url = `${baseUrl}/api/products/${id}`;

		try {
			const response = await axios.get(url);

			if (response?.data?.success) {
				setProduct(response?.data?.data);
			}
		} catch (error) {
			console.log("Error occurred:", error);
		}
	}, [id]);

	// Function to fetch products by filter
	const fetchFilteredProducts = useCallback(
		async (filterData = "", page = 1) => {
			const url = `${baseUrl}/api/products/filter?filterByBodyPart=${encodeURIComponent(
				filterData
			)}&page=${page}`;

			try {
				const response = await axios.get(url);

				if (response?.data?.success) {
					setFilteredProducts(response?.data?.data?.products || []);
					setFilterPaginationInfo({
						currentPage: response?.data?.data?.pagination?.currentPage,
						totalPages: response?.data?.data?.pagination?.totalPages,
						totalProducts: response?.data?.data?.pagination?.totalProducts,
					});
				}
			} catch (error) {
				console.error("Error fetching filtered products:", error);
			}
		},
		[]
	);

	// Function to fetch products by brane name
	const fetchBrandProducts = useCallback(
		async (brandName = "", filterByBodyPart = "", page = 1) => {
			const url = `${baseUrl}/api/products/filter?brandName=${brandName}&filterByBodyPart=${filterByBodyPart}&page=${page}`;

			try {
				const response = await axios.get(url);

				if (response?.data?.success) {
					setBrandProducts(response?.data?.data?.products || []);
					setBrandPaginationInfo({
						currentPage: response?.data?.data?.pagination?.currentPage,
						totalPages: response?.data?.data?.pagination?.totalPages,
						totalProducts: response?.data?.data?.pagination?.totalProducts,
					});
				}
			} catch (error) {
				console.error("Error fetching brand products:", error);
			}
		},
		[]
	);

	// Function to fetch products by brane name
	const fetchGlobalSearch = useCallback(
		async (page = 1) => {
			const url = `${baseUrl}/api/products/search?query=${searchQuery}&page=${page}`;

			try {
				const response = await axios.get(url);

				if (response?.data?.success) {
					setGlobalSearchData(response?.data?.data?.products || []);
					setGlobalSearchPagination({
						currentPage: response?.data?.data?.pagination?.currentPage,
						totalPages: response?.data?.data?.pagination?.totalPages,
						totalProducts: response?.data?.data?.pagination?.totalProducts,
					});
				}
			} catch (error) {
				console.error("Error fetching brand products:", error);
			}
		},
		[searchQuery]
	);

	const handleSearchClick = (selectedSearch) => {
		setSelectedSearchData(selectedSearch);
		setIsDebounceDropdown(false);
		const queryParam = productsToBeSearched.join("$");
		navigate(`/search?products=${encodeURIComponent(queryParam)}`);
	};

	// Function to fetch products by product type
	const fetchByProductType = useCallback(async (filterData = "", page = 1) => {
		const url = `${baseUrl}/api/products/filter?productType=${encodeURIComponent(
			filterData
		)}&page=${page}`;

		try {
			const response = await axios.get(url);

			if (response?.data?.success) {
				setProductTypeData(response?.data?.data?.products || []);
				setProductTypePagination({
					currentPage: response?.data?.data?.pagination?.currentPage,
					totalPages: response?.data?.data?.pagination?.totalPages,
					totalProducts: response?.data?.data?.pagination?.totalProducts,
				});
			}
		} catch (error) {
			console.error("Error fetching filtered products:", error);
		}
	}, []);

	// Products by category
	const fetchProductsByCategories = useCallback(async (page = 1) => {
		const url = `${baseUrl}/api/products/all-packages?page=${page}`;

		try {
			const response = await axios.get(url);
			if (response?.data?.success) {
				const productsData = response?.data?.data?.products || [];
				const paginationData = response?.data?.data?.pagination || {};

				// Append new products to the existing list
				setCategoryProducts((prevProducts) => [
					...prevProducts,
					...productsData,
				]);
				setCategoryProductsPagination(paginationData);
			} else {
				console.error("Failed to fetch products:", response?.data?.message);
			}
		} catch (error) {
			console.error("Error fetching products:", error);
		}
	}, []);

	// Radiology products with pagination
	const fetchRadiologyProducts = useCallback(
		async (page = 1) => {
			try {
				const url = `${baseUrl}/api/products/radiology-products?page=${page}`;
				const response = await axios.get(url);

				if (response?.data?.success) {
					const { products, pagination } = response?.data?.data;

					// Append new products instead of replacing them
					setRadiologyProducts((prevProducts) => [
						...prevProducts,
						...products,
					]);
					setRadiologyProductsPagination(pagination);
				} else {
					console.error("Error:", response?.data?.message);
				}
			} catch (err) {
				console.error("Error fetching Radiology products:", err?.message);
			}
		},
		[baseUrl]
	);

	// Fetch products by brandName & productType
	const fetchProductsByBrandAndType = useCallback(
		async (brandName, productType) => {
			try {
				const url = `${baseUrl}/api/products/brand-and-type-products`;
				const response = await axios.get(url, {
					params: { brandName, productType },
				});
				if (response?.data?.success) {
					setProductsByBrandAndType(response.data.products);
				} else {
					console.error("Error:", response?.data?.message);
				}
			} catch (error) {
				console.error("Failed to fetch products:", error);
			}
		},
		[baseUrl]
	);

	// Fetch products by brandName & searchQuery
	const fetchProductsByBrandAndQuery = useCallback(
		async (brandName, searchQuery) => {
			try {
				const url = `${baseUrl}/api/products/brand-and-query-products`;
				const response = await axios.get(url, {
					params: { brandName, searchQuery },
				});
				if (response?.data?.success) {
					setProductsByBrandAndQuery(response.data.products);
				} else {
					console.error("Error:", response?.data?.message);
				}
			} catch (error) {
				console.error("Failed to fetch products:", error);
			}
		},
		[baseUrl]
	);

	// Fetch products by brandName, productType & searchQuery
	const fetchProductsByBrandAndTypeAndQuery = useCallback(
		async (brandName, productType, searchQuery = "", page = 1) => {
			try {
				const url = `${baseUrl}/api/products/brand-and-type-and-query-products`;
				const response = await axios.get(url, {
					params: { brandName, productType, searchQuery, page },
				});

				if (response?.data?.success) {
					setProductsByBrandAndTypeAndQuery((prev) => [
						...prev,
						...response.data.products,
					]);
					setProductsByBrandAndTypeAndQueryPagination({
						currentPage: response?.data?.pagination?.currentPage,
						totalPages: response?.data?.pagination?.totalPages,
						totalProducts: response?.data?.pagination?.totalProducts,
					});
				} else {
					console.error("Error:", response?.data?.message);
				}
			} catch (error) {
				console.error("Failed to fetch products:", error);
			}
		},
		[baseUrl]
	);

	// Fetch all popular products
	const fetchPopularProducts = useCallback(async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/api/products/popular-products`
			);
			// console.log("Popular Products Response:", response );
			if (response?.data?.success) {
				setPopularProducts(response?.data?.data || []);
			} else {
				console.error(
					"Error fetching popular products:",
					response?.data?.message
				);
			}
		} catch (error) {
			console.error("Failed to fetch popular products:", error);
		}
	}, [baseUrl]);

	// useEffect(() => {
	// 	fetchPopularProducts();
	// }, [fetchPopularProducts]);



	// const fetchPopularProducts = useCallback(async () => {
	// 	try {
	// 		const response = await axios.get(
	// 			`${baseUrl}/api/products/popular-products`
	// 		);

	// 		if (response?.data?.success) {
	// 			const sortedProducts = (response.data.data || []).sort(
	// 				(a, b) => Number(a.sellingPrice) - Number(b.sellingPrice)
	// 			);
	// 			console.log("Sorted Products:", sortedProducts);
	// 			setPopularProducts(sortedProducts);
	// 		} else {
	// 			console.error(
	// 				"Error fetching popular products:",
	// 				response?.data?.message
	// 			);
	// 		}
	// 	} catch (error) {
	// 		console.error("Failed to fetch popular products:", error);
	// 	}
	// }, [baseUrl]);

	const handleAddProductsToBeSearched = (productsToBeSearched) => {
		setProductsToBeSearched((prev) => {
			// Check if the item already exists based on some unique property (e.g., id or name)

			if (prev.some((product) => product === productsToBeSearched)) {
				return prev; // Return previous state if the product already exists
			}
			// If the product doesn't exist, add it to the list
			return [...prev, productsToBeSearched];
		});
		setGlobalSearchQuery("");
		setNavbarSearchQuery("");
	};

	const handleRemoveProductsToBeSearched = (product) => {
		setProductsToBeSearched((prev) => prev.filter((item) => item !== product));
	};

	const fetchAllSearchedProducts = async (productsToBeSearched) => {
		try {
			const response = await axios.post(
				`${baseUrl}/api/products/query-products`,
				{
					words: productsToBeSearched,
					isAddMoreTest: false,
					page: 1,
				}
			);

			if (response?.data?.success) {
				// setAllProductsSearched(response?.data?.products || []);
				return response?.data?.products || [];
			} else {
				console.error(
					"Error fetching popular products:",
					response?.data?.message
				);
			}
		} catch (error) {
			console.error("Failed to fetch popular products:", error);
		}
	};

	const fetchSearchedProduct = async (
		product,
		addMoreTest = false,
		currentPage
	) => {
		try {
			const response = await axios.post(
				`${baseUrl}/api/products/query-products`,
				{
					words: [product],
					isAddMoreTest: addMoreTest,
					page: currentPage,
				}
			);

			if (response?.data?.success) {
				setProductsBySearchQueryPagination({
					currentPage: response?.data?.pagination?.currentPage,
					totalPages: response?.data?.pagination?.totalPages,
					totalProducts: response?.data?.pagination?.totalProducts,
				});
				return response?.data?.products || [];
			} else {
				console.error(
					"Error fetching popular products:",
					response?.data?.message
				);
			}
		} catch (error) {
			console.error("Failed to fetch popular products:", error);
		}
	};

	useEffect(() => {
		const fetchAllSearchedProducts = async () => {
			console.log("fromProductFilter", fromProductFilter.text);
			try {
				const response = await axios.post(
					`${baseUrl}/api/products/query-products`,
					{
						words: [fromProductFilter.text],
						isAddMoreTest: false,
						page: 1,
					}
				);

				if (response?.data?.success) {
					console.log(response?.data);
					setAllProductsSearched(response?.data?.products || []);
				} else {
					console.error(
						"Error fetching popular products:",
						response?.data?.message
					);
				}
			} catch (error) {
				console.error("Failed to fetch popular products:", error);
			}
		};

		if (fromProductFilter.text) {
			fetchAllSearchedProducts();
		}
	}, [fromProductFilter]);

	const handleSearchByBrandName = async (
		formattedBrandName,
		productsToBeSearched
	) => {
		console.log(formattedBrandName, productsToBeSearched);
		try {
			const response = await axios.post(
				`${baseUrl}/api/products/query-products-by-brand`,
				{
					brandName: formattedBrandName,
					words: productsToBeSearched,
					isAddMoreTest: false,
					page: 1,
				}
			);

			if (response?.data?.success) {
				console.log(response?.data);
				setProductsByBrandAndQuery(response?.data?.products || []);
			} else {
				console.error(
					"Error fetching popular products:",
					response?.data?.message
				);
			}
		} catch (error) {
			console.error("Failed to fetch popular products:", error);
		}
	};

	// const groq = new Groq({
	//   apiKey: "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",
	//   dangerouslyAllowBrowser: true,
	// });

	// const ai = new GoogleGenAI({ apiKey: "AIzaSyCaRvYDxAUPLyM95LsppjgwKbQPcztoxvE" });

	// Fetch products by brandName, productType & searchQuery
	const fetchProductsBySearchQuery = async (searchQuery = "", page = 1) => {
		const productTitles = await getProductTitles(searchQuery);
		setProductsBySearchQuery(productTitles);

		// try {
		//       const url = `${baseUrl}/api/products/allproducts?page=${1}`;
		//       const response = await axios.get(url);
		//       let productTitleList = response?.data?.data?.products.map((product) => product.productTitle)
		//       let count = 0;
		//       for (let product of productTitleList) {
		//         if (await checkProductTitle(product)){
		//           console.log("Product Title exists", product);
		//         } else{
		//           if (product) {
		//           const otherProducts = productTitleList.filter((otherProduct) => otherProduct !== product);
		//           console.log("Main Product", product);

		//           let success = false;
		//           let retryCount = 0;
		//           const maxRetries = 3;  // Maximum number of retry attempts

		//           while (!success && retryCount < maxRetries) {
		//             try {
		//               const response = await ai.models.generateContent({
		//                 model: "gemini-2.0-flash",
		//                 contents: `Test Name: ${product}`,
		//                 config: {
		//                   systemInstruction: `You are an AI assistant designed to identify similar or matching tests from a product list.

		//                   List of Products: ${JSON.stringify(otherProducts)}

		//                   TASK:
		//                   From the provided List of Products, identify and return ONLY those tests/products that are similar to, variations of, or match the given Test Name. A match could be:
		//                   1. Tests that are synonyms or alternate names for the Test Name
		//                   2. Tests that are essentially the same test but worded differently
		//                   3. Tests where the Test Name is a subset of the product or vice versa
		//                   4. Tests that are medically equivalent or typically used for the same purpose

		//                   CRITICAL RULES:
		//                   1. ONLY return tests from the provided List of Products - do not invent new names
		//                   2. Only include a test if it's genuinely related to or similar to the Test Name
		//                   3. Do not include tests that happen to share a common word but are medically different tests
		//                   4. Pay attention to test panels - a "Complete Blood Count" is related to "CBC" but not to "Liver Function Test"
		//                   5. Medical relevance matters more than linguistic similarity
		//                   6. Return the exact test names as they appear in the List of Products, without modifications
		//                   7. Sort the results from most relevant/similar to least relevant/similar to the Test Name

		//                   EXAMPLES:
		//                   - If Test Name is "Complete Blood Count" and the list includes "CBC", "Blood Test Panel", and "Kidney Function Test", return ["CBC", "Blood Test Panel"]
		//                   - If Test Name is "Liver Function Test" and the list includes "LFT", "Comprehensive Liver Profile", and "Thyroid Panel", return ["LFT", "Comprehensive Liver Profile"]
		//                   - If Test Name is "X-Ray Chest" and the list includes "Digital X-Ray Chest", "Chest Radiograph", and "CT Scan Chest", return ["Digital X-Ray Chest", "Chest Radiograph"]

		//                   OUTPUT FORMAT:
		//                   Return a JSON array containing only the matching tests from the List of Products, sorted from most relevant to least relevant. Return only the array, no other text or explanations:
		//                   Example: ["CBC", "Complete Blood Count", "Blood Test Panel"]
		//                   Remember: Only return tests from the provided list that are truly medically related to or variations of the given Test Name. If no matches are found, return an empty array: []`
		//                 }
		//               });

		//               let responseContent = response.text;

		//               // Clean the response to handle various JSON formatting issues
		//               responseContent = responseContent.replace(/```json|```/g, '').trim();

		//               // Try to find a valid JSON array in the response
		//               let jsonMatch = responseContent.match(/\[.*\]/s);
		//               let itemsList = [];

		//               if (jsonMatch) {
		//                 try {
		//                   itemsList = JSON.parse(jsonMatch[0]);
		//                   // If we get here, parsing succeeded
		//                   success = true;
		//                   await updateAlsoKnownAs(product, itemsList);
		//                   console.log(`Successfully processed "${product}" on attempt ${retryCount + 1}`);
		//                 } catch (parseError) {
		//                   retryCount++;
		//                   console.error(`JSON parsing error for "${product}" (attempt ${retryCount}/${maxRetries}):`, parseError);
		//                   // Wait before retrying to avoid rate limiting
		//                   await new Promise(resolve => setTimeout(resolve, 2000));
		//                 }
		//               } else {
		//                 retryCount++;
		//                 console.error(`No valid JSON array found for "${product}" (attempt ${retryCount}/${maxRetries})`);
		//                 console.log("Response content:", responseContent);
		//                 // Wait before retrying
		//                 await new Promise(resolve => setTimeout(resolve, 2000));
		//               }
		//             } catch (error) {
		//               retryCount++;
		//               console.error(`API error for "${product}" (attempt ${retryCount}/${maxRetries}):`, error);
		//               // Wait before retrying
		//               await new Promise(resolve => setTimeout(resolve, 2000));
		//             }
		//           }

		//           if (!success) {
		//             console.error(`Failed to process "${product}" after ${maxRetries} attempts. Moving to next product.`);
		//           }

		//           count++;
		//           console.log("Processed Word no.", count);
		//         } else {
		//           count++;
		//           console.log("Main Product", product);
		//           console.log("Already in mongo db", count);
		//         }
		//         }

		//        }

		//     } catch (error) {
		//       console.error("Failed to fetch products:", error);
		//     }
	};

	const createAlsoKnownAs = async (productTitle, alsoKnownAs) => {
		try {
			const response = await axios.post(
				`${baseUrl}/api/alsoKnownAs/create-alsoKnownAs`,
				{
					productTitle: productTitle,
					alsoKnownAsWords: alsoKnownAs,
				}
			);

			if (response?.data?.success) {
			} else {
				console.error(
					"Error fetching popular products:",
					response?.data?.message
				);
			}
		} catch (error) {
			console.error("Failed to add alsoKnownAs:", error);
		}
	};

	const deleteAlsoKnownAs = async (mainWord) => {
		try {
			const response = await axios.post(
				`${baseUrl}/api/alsoKnownAs/delete-alsoKnownAs`,
				{
					data: {
						mainWord: mainWord,
					},
				}
			);

			if (response?.data?.success) {
				console.log(`Successfully deleted alsoKnownAs for: ${mainWord}`);
				return response.data;
			} else {
				console.error("Error deleting alsoKnownAs:", response?.data?.message);
				return null;
			}
		} catch (error) {
			console.error("Failed to delete alsoKnownAs:", error);
			return null;
		}
	};

	const updateAlsoKnownAs = async (mainWord, nameArray) => {
		try {
			const response = await axios.post(
				`${baseUrl}/api/alsoKnownAs/update-alsoKnownAs`,
				{
					mainWord: mainWord,
					nameArray: nameArray,
				}
			);

			if (response?.data?.success) {
				console.log(`AlsoKnownAs updated successfully for: ${mainWord}`);
				console.log("Updated Product IDs:", response.data.productIds);
			} else {
				console.error("Error updating AlsoKnownAs:", response?.data?.message);
			}
		} catch (error) {
			console.error("Failed to update AlsoKnownAs:", error);
		}
	};

	const getProductTitles = async (searchQuery) => {
		try {
			const response = await axios.post(
				`${baseUrl}/api/alsoKnownAs/getProductTitles`,
				{
					searchQuery: searchQuery,
				}
			);

			if (response?.data?.success) {
				return response?.data?.productTitles;
			} else {
				console.error(
					"Error fetching popular products:",
					response?.data?.message
				);
			}
		} catch (error) {
			console.error("Failed to add alsoKnownAs:", error);
		}
	};

	const checkProductTitle = async (productTitle) => {
		try {
			const response = await axios.post(
				`${baseUrl}/api/alsoKnownAs/check-productTitle`,
				{
					productTitle: productTitle,
				}
			);

			if (response?.data?.success) {
				return true; // Product title exists
			} else {
				return false; // Product title does not exist
			}
		} catch (error) {
			console.error("Error checking product title:", error);
			return false;
		}
	};

	return (
		<TestContext.Provider
			value={{
				fetchProducts,
				allProducts,
				fetchProductById,
				product,
				fetchFilteredProducts,
				filteredProducts,
				filters,
				setFilters,
				paginationInfo,
				filterPaginationInfo,
				fetchBrandProducts,
				brandProducts,
				brandPaginationInfo,
				fetchGlobalSearch,
				searchQuery,
				setSearchQuery,
				handleGlobalSearchChange,
				globalSearchData,
				setGlobalSearchPagination,
				globalSearchPagination,
				selectedSearchData,
				setSelectedSearchData,
				handleSearchClick,
				isDebounceDropdown,
				setIsDebounceDropdown,
				selectedProductType,
				setSelectedProductType,
				fetchByProductType,
				productTypeData,
				productTypePagination,
				fetchProductsByCategories,
				categoryProducts,
				categoryProductsPagination,
				fetchRadiologyProducts,
				radiologyProducts,
				radiologyProductsPagination,
				fetchProductsByBrandAndType,
				productsByBrandAndType,
				fetchProductsByBrandAndQuery,
				productsByBrandAndQuery,
				setProductsByBrandAndQuery,
				globalSearchQuery,
				setGlobalSearchQuery,
				fetchProductsByBrandAndTypeAndQuery,
				productsByBrandAndTypeAndQuery,
				setProductsByBrandAndTypeAndQuery,
				productsByBrandAndTypeAndQueryPagination,
				fetchPopularProducts,
				popularProducts,
				productsBySearchQuery,
				setProductsBySearchQuery,
				fetchProductsBySearchQuery,
				productsToBeSearched,
				setProductsToBeSearched,
				handleAddProductsToBeSearched,
				handleRemoveProductsToBeSearched,
				fetchAllSearchedProducts,
				allProductsSearched,
				setAllProductsSearched,
				searchedProducts,
				setSearchedProducts,
				setFromProductFilter,
				fromProductFilter,
				fetchSearchedProduct,
				productsBySearchQueryPagination,
				handleSearchByBrandName,
				navbarSearchQuery,
				setNavbarSearchQuery,
			}}>
			{children}
		</TestContext.Provider>
	);
};

export const useTestContext = () => useContext(TestContext);

export default TestProvider;
